import React from "react";
import {MenuCampaignMaster} from "../organism/MASTER/Apollo_MasterModel";

export type ColumnData = {
  download: boolean,
  label: string,
}

export type ChartColumnData = {
  index: number,
  viewPattern: number,
  label: string,
}

export type CsvData = {
  index: number,
  data: any[],
}

export const DefaultMenuMaster: MenuCampaignMaster = {
  menuId: -1,
  menuName: "",
  campaignKindId: 0,
  campaignKindName: "",
  budgetAmountFlg: 0,
  accountCheckFlg: 0,
}

export const options_csv_ms_os_type = [
  {value: 1, label: "iOS/Android"},
  {value: 2, label: "Android"},
  {value: 3, label: "iOS"},
];

// 配信種別（パフォーマンス広告）
export const optionsZeusDeliveryShortType = [
  {value: 1, label: "Performance"},
  {value: 2, label: "コネパスDSP"},
];

// 配信種別（パフォーマンス広告）
export const optionsZeusDeliveryType = [
  {value: 1, label: "Performance Network"},
  {value: 2, label: "docomo connecting path DSP"},
];

// CSVカラム (グラフ)
export const ChartColumns1: ChartColumnData[] = [
  {index: 0, viewPattern: 1, label:"date"},
  {index: 1, viewPattern: 3, label:"cost"},
  {index: 2, viewPattern: 2, label:"imp"},
  {index: 3, viewPattern: 2, label:"vimp"},
  {index: 4, viewPattern: 2, label:"click"},
  {index: 5, viewPattern: 4, label:"CTR"},
  {index: 6, viewPattern: 4, label:"vCTR"},
  {index: 7, viewPattern: 3, label:"平均CPC"},
  {index: 8, viewPattern: 3, label:"CPM"},
  {index: 9, viewPattern: 2, label:"計測ポイントCV(total)"},
  {index: 10, viewPattern: 2, label:"計測ポイントCV(ラストクリック)"},
  {index: 11, viewPattern: 2, label:"計測ポイントCV(アシスト)"},
  {index: 12, viewPattern: 3, label:"計測ポイントCPA(total)"},
  {index: 13, viewPattern: 3, label:"計測ポイントCPA(ラストクリック)"},
  {index: 14, viewPattern: 3, label:"計測ポイントCPA(アシスト)"},
  {index: 15, viewPattern: 4, label:"計測ポイントCVR(total)"},
  {index: 16, viewPattern: 4, label:"計測ポイントCVR(ラストクリック)"},
  {index: 17, viewPattern: 4, label:"計測ポイントCVR(アシスト)"},
  {index: 18, viewPattern: 2, label:"最適化ポイントCV"},
  // {index: 19, viewPattern: 2, label:"最適化ポイントCV(ラストクリック)"},
  // {index: 20, viewPattern: 2, label:"最適化ポイントCV(アシスト)"},
  {index: 19, viewPattern: 3, label:"最適化ポイントCPA"},
  // {index: 22, viewPattern: 3, label:"最適化ポイントCPA(ラストクリック)"},
  // {index: 23, viewPattern: 3, label:"最適化ポイントCPA(アシスト)"},
  {index: 20, viewPattern: 4, label:"最適化ポイントCVR"},
  // {index: 25, viewPattern: 4, label:"最適化ポイントCVR(ラストクリック)"},
  // {index: 26, viewPattern: 4, label:"最適化ポイントCVR(アシスト)"},
];

export const ChartColumns2: ChartColumnData[] = [
  {index: 0, viewPattern: 1, label:"date"},
  {index: 1, viewPattern: 3, label:"cost"},
  {index: 2, viewPattern: 2, label:"imp"},
  {index: 4, viewPattern: 2, label:"click"},
  {index: 5, viewPattern: 4, label:"CTR"},
  {index: 7, viewPattern: 3, label:"平均CPC"},
  {index: 8, viewPattern: 3, label:"CPM"},
  {index: 9, viewPattern: 2, label:"計測ポイントCV(total)"},
  {index: 10, viewPattern: 2, label:"計測ポイントCV(ラストクリック)"},
  {index: 11, viewPattern: 2, label:"計測ポイントCV(アシスト)"},
  {index: 12, viewPattern: 3, label:"計測ポイントCPA(total)"},
  {index: 13, viewPattern: 3, label:"計測ポイントCPA(ラストクリック)"},
  {index: 14, viewPattern: 3, label:"計測ポイントCPA(アシスト)"},
  {index: 15, viewPattern: 4, label:"計測ポイントCVR(total)"},
  {index: 16, viewPattern: 4, label:"計測ポイントCVR(ラストクリック)"},
  {index: 17, viewPattern: 4, label:"計測ポイントCVR(アシスト)"},
];

// CSVカラム (datatables)
export const AccountSummaryColumns: ColumnData[] = [
  {download: true, label: "広告主アカウントID"},
  {download: true, label: "広告主アカウント名"},
  {download: true, label: "アカウントグループ_ID"},
  {download: true, label: "アカウントグループ名"},
  {download: true, label: "ステータス"},
  {download: true, label: "cost"},
  {download: true, label: "imp"},
  {download: true, label: "vimp"},
  {download: true, label: "click"},
  {download: true, label: "CTR"},
  {download: true, label: "vCTR"},
  {download: true, label: "平均CPC"},
  {download: true, label: "CPM"},
  {download: true, label: "計測ポイントCV(total)"},
  {download: true, label: "計測ポイントCV(ラストクリック)"},
  {download: true, label: "計測ポイントCV(アシスト)"},
  {download: true, label: "計測ポイントCPA(total)"},
  {download: true, label: "計測ポイントCPA(ラストクリック)"},
  {download: true, label: "計測ポイントCPA(アシスト)"},
  {download: true, label: "計測ポイントCVR(total)"},
  {download: true, label: "計測ポイントCVR(ラストクリック)"},
  {download: true, label: "計測ポイントCVR(アシスト)"},
  {download: true, label: "最適化ポイントCV"},
  {download: true, label: "最適化ポイントCPA"},
  {download: true, label: "最適化ポイントCVR"},
];

export const UserColumns: ColumnData[] = [
  {download: true, label: "ユーザーID"},
  {download: true, label: "メールアドレス"},
  {download: true, label: "氏名(姓)"},
  {download: true, label: "氏名(名)"},
  {download: true, label: "所有ロール数"},
  {download: true, label: "システム権限"},
];

export const BudgetColumns: ColumnData[] = [
  {download: true, label: "広告主アカウントID"},
  {download: true, label: "広告主アカウント名"},
  {download: true, label: "アカウントグループID"},
  {download: true, label: "アカウントグループ名"},
  {download: true, label: "アカウント月額予算"},
  {download: true, label: "メッセージS"},
  {download: true, label: "パフォーマンス広告"},
  {download: true, label: "パフォーマンス広告_Performance"},
  {download: true, label: "パフォーマンス広告_コネパスDSP"},
];

export const AccountGroupColumns: ColumnData[] = [
  {download: true, label: "アカウントグループID"},
  {download: true, label: "アカウントグループ名"},
  {download: true, label: "ステータス"},
  {download: true, label: "作成日"},
  {download: true, label: "作成者"},
];

export const AccountColumns: ColumnData[] = [
  {download: true, label: "広告主アカウントID"},
  {download: true, label: "広告主アカウント名"},
  {download: true, label: "当月予算"},
  {download: true, label: "広告主名"},
  {download: true, label: "ステータス"},
  {download: true, label: "承認状況"},
  {download: true, label: "パフォーマンス広告"},
  {download: true, label: "メール広告"},
];

export const MasterProductColumns: ColumnData[] = [
  {download: true, label: "商品ID"},
  {download: true, label: "広告主名"},
  {download: true, label: "商品名称"},
  {download: true, label: "業種ID"},
  {download: true, label: "業種カテゴリ"},
  {download: true, label: "業種"},
];

export const MasterIndustryColumns: ColumnData[] = [
  {download: true, label: "業種ID"},
  {download: true, label: "業種カテゴリ"},
  {download: true, label: "業種"},
  {download: true, label: "商品数"},
];

export const MasterBillingResourceColumns: ColumnData[] = [
  {download: true, label: "請求リソースID"},
  {download: true, label: "請求リソース名称"},
  {download: true, label: "与信限度額"},
];

export const CampaignColumns: ColumnData[] = [
  {download: true, label: "キャンペーンID"},
  {download: true, label: "メニュー"},
  {download: true, label: "キャンペーン種別"},
  {download: true, label: "取引形式"},
  {download: true, label: "キャンペーン名"},
  {download: true, label: "ステータス"},
  {download: true, label: "キャンペーンの目的"},
  {download: true, label: "課金種別"},
  {download: true, label: "日予算"},
  {download: true, label: "掲載開始日時"},
  {download: true, label: "掲載終了日時"},
  {download: true, label: "目標CPA"},
  {download: true, label: "配信先ドメイン設定"},
  {download: true, label: "cost"},
  {download: true, label: "imp"},
  {download: true, label: "vimp"},
  {download: true, label: "click"},
  {download: true, label: "CTR"},
  {download: true, label: "vCTR"},
  {download: true, label: "平均CPC"},
  {download: true, label: "CPM"},
  {download: true, label: "計測ポイントCV(total)"},
  {download: true, label: "計測ポイントCV(ラストクリック)"},
  {download: true, label: "計測ポイントCV(アシスト)"},
  {download: true, label: "計測ポイントCPA(total)"},
  {download: true, label: "計測ポイントCPA(ラストクリック)"},
  {download: true, label: "計測ポイントCPA(アシスト)"},
  {download: true, label: "計測ポイントCVR(total)"},
  {download: true, label: "計測ポイントCVR(ラストクリック)"},
  {download: true, label: "計測ポイントCVR(アシスト)"},
  {download: true, label: "最適化ポイントCV"},
  {download: true, label: "最適化ポイントCPA"},
  {download: true, label: "最適化ポイントCVR"},
];

export const AdGroupsZeusColumns: ColumnData[] = [
  {download: true, label: "広告グループID"},
  {download: true, label: "広告グループ名"},
  {download: true, label: "キャンペーン名"},
  {download: true, label: "キャンペーン種別"},
  {download: true, label: "取引形式"},
  {download: true, label: "プレースメント"},
  {download: true, label: "ステータス"},
  {download: true, label: "課金種別"},
  {download: true, label: "目標CPC"},
  {download: true, label: "上限CPM"},
  {download: true, label: "配信OS"},
  {download: true, label: "ターゲティング"},
  {download: true, label: "デモグラ情報_性別"},
  {download: true, label: "デモグラ情報_年齢"},
  {download: true, label: "デモグラ情報_居住地"},
  {download: true, label: "cost"},
  {download: true, label: "imp"},
  {download: true, label: "click"},
  {download: true, label: "CTR"},
  {download: true, label: "平均CPC"},
  {download: true, label: "CPM"},
  {download: true, label: "計測ポイントCV(total)"},
  {download: true, label: "計測ポイントCV(ラストクリック)"},
  {download: true, label: "計測ポイントCV(アシスト)"},
  {download: true, label: "計測ポイントCPA(total)"},
  {download: true, label: "計測ポイントCPA(ラストクリック)"},
  {download: true, label: "計測ポイントCPA(アシスト)"},
  {download: true, label: "計測ポイントCVR(total)"},
  {download: true, label: "計測ポイントCVR(ラストクリック)"},
  {download: true, label: "計測ポイントCVR(アシスト)"},
  {download: true, label: "最適化ポイントCV"},
  {download: true, label: "最適化ポイントCPA"},
  {download: true, label: "最適化ポイントCVR"},
];

export const AdGroupsMsColumns: ColumnData[] = [
  {download: true, label: "広告グループID"},
  {download: true, label: "広告グループ名"},
  {download: true, label: "キャンペーン名"},
  {download: true, label: "キャンペーン種別"},
  {download: true, label: "ステータス"},
  {download: true, label: "広告種別"},
  {download: true, label: "課金種別"},
  {download: true, label: "入札単価"},
  {download: true, label: "配信OS"},
  {download: true, label: "ターゲティング"},
  {download: true, label: "cost"},
  {download: true, label: "imp"},
  {download: true, label: "click"},
  {download: true, label: "CTR"},
  {download: true, label: "平均CPC"},
  {download: true, label: "CPM"},
  {download: true, label: "計測ポイントCV(total)"},
  {download: true, label: "計測ポイントCV(ラストクリック)"},
  {download: true, label: "計測ポイントCV(アシスト)"},
  {download: true, label: "計測ポイントCPA(total)"},
  {download: true, label: "計測ポイントCPA(ラストクリック)"},
  {download: true, label: "計測ポイントCPA(アシスト)"},
  {download: true, label: "計測ポイントCVR(total)"},
  {download: true, label: "計測ポイントCVR(ラストクリック)"},
  {download: true, label: "計測ポイントCVR(アシスト)"},
];

export const AdvertisementZeusColumns: ColumnData[] = [
  {download: true, label: "広告ID"},
  {download: true, label: "広告名"},
  {download: true, label: "広告グループ名"},
  {download: true, label: "キャンペーン名"},
  {download: true, label: "キャンペーン種別"},
  {download: true, label: "取引形式"},
  {download: true, label: "広告種別"},
  {download: true, label: "ステータス"},
  {download: true, label: "審査ステータス"},
  {download: true, label: "アセット1_ID"},
  {download: true, label: "アセット1_URL"},
  {download: true, label: "アセット2_ID"},
  {download: true, label: "アセット2_URL"},
  {download: true, label: "見出し1"},
  {download: true, label: "見出し2"},
  {download: true, label: "見出し3"},
  {download: true, label: "説明文1"},
  {download: true, label: "説明文2"},
  {download: true, label: "説明文3"},
  {download: true, label: "情報提供者名"},
  {download: true, label: "ClickToAction"},
  {download: true, label: "最終リンク先URL"},
  {download: true, label: "情報提供者ドメイン"},
  {download: true, label: "cost"},
  {download: true, label: "imp"},
  {download: true, label: "click"},
  {download: true, label: "CTR"},
  {download: true, label: "平均CPC"},
  {download: true, label: "CPM"},
  {download: true, label: "計測ポイントCV(total)"},
  {download: true, label: "計測ポイントCV(ラストクリック)"},
  {download: true, label: "計測ポイントCV(アシスト)"},
  {download: true, label: "計測ポイントCPA(total)"},
  {download: true, label: "計測ポイントCPA(ラストクリック)"},
  {download: true, label: "計測ポイントCPA(アシスト)"},
  {download: true, label: "計測ポイントCVR(total)"},
  {download: true, label: "計測ポイントCVR(ラストクリック)"},
  {download: true, label: "計測ポイントCVR(アシスト)"},
  {download: true, label: "最適化ポイントCV"},
  {download: true, label: "最適化ポイントCPA"},
  {download: true, label: "最適化ポイントCVR"},
];

export const AdvertisementMsColumns: ColumnData[] = [
  {download: true, label: "広告ID"},
  {download: true, label: "広告名"},
  {download: true, label: "広告グループ名"},
  {download: true, label: "キャンペーン名"},
  {download: true, label: "キャンペーン種別"},
  {download: true, label: "ステータス"},
  {download: true, label: "審査ステータス"},
  {download: true, label: "アセットID"},
  {download: true, label: "cost"},
  {download: true, label: "imp"},
  {download: true, label: "click"},
  {download: true, label: "CTR"},
  {download: true, label: "平均CPC"},
  {download: true, label: "CPM"},
  {download: true, label: "計測ポイントCV(total)"},
  {download: true, label: "計測ポイントCV(ラストクリック)"},
  {download: true, label: "計測ポイントCV(アシスト)"},
  {download: true, label: "計測ポイントCPA(total)"},
  {download: true, label: "計測ポイントCPA(ラストクリック)"},
  {download: true, label: "計測ポイントCPA(アシスト)"},
  {download: true, label: "計測ポイントCVR(total)"},
  {download: true, label: "計測ポイントCVR(ラストクリック)"},
  {download: true, label: "計測ポイントCVR(アシスト)"},
];

export const CrAssetMsColumns: ColumnData[] = [
  {download: true, label: "広告アセットID"},
  {download: true, label: "広告アセット名"},
  {download: true, label: "フォーマットタイプ"},
  {download: true, label: "広告設定"},
];

export const SegmentCustomColumns: ColumnData[] = [
  {download: true, label: "ID"},
  {download: true, label: "アカウントグループID"},
  {download: true, label: "ステータス"},
  {download: true, label: "セグメント名"},
  {download: true, label: "UU"},
  {download: true, label: "アカウント連携"},
  {download: true, label: "用途設定"},
  {download: true, label: "タイプ"},
  {download: true, label: "利用設定"},
  {download: true, label: "最終更新ユーザ"},
  {download: true, label: "最終更新"},
];

export const RESULT_KBN = {
    SUCCESS: 0,
    INFO: 1,
    PARAMETER_ERROR: -1,
    ERROR: -9,
}

export const ROW_PER_PAGE_OPTIONS = {
    HOME_AND_MAIN_LEVELS: [10, 30, 100],
    OTHER_PAGES: [10, 20, 50],
}